module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-full-width",
    attrs: {
      "name": "hrms6ae-popup",
      "id": "hrms6ae-popup",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['STDATTEN']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columnsDetailPopup,
      "data": _vm.detailPopup.table,
      "maxRowspan": _vm.maxRowspanPopup
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65b72040!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms6ae/popup.vue
// module id = 3823
// module chunks = 1